<template>
  <v-dialog lazy full-width width="290px" ref="dialog" v-model="visible">
    <v-text-field
      slot="activator"
      :value="display"
      @click:append="clearable && modified ? clear() : null"
      :append-icon="clearable && modified ? 'mdi-close' : appendIcon"
      :error-messages="errorMessages"
      :placeholder="placeholder"
      :label="label"
      :required="required"
      :rules="rules"
      :hint="hint"
      :prepend-icon="prependIcon"
      persistent-hint
      readonly
    />

    <v-card>
      <v-tabs fixed-tabs v-model="activeTab" v-if="type === 'datetime'">
        <v-tab key="calendar">
          <slot name="dateIcon">
            <v-icon>mdi-calendar</v-icon>
          </slot>
        </v-tab>
        <v-tab key="timer" :disabled="!dateSelected">
          <slot name="timeIcon">
            <v-icon>mdi-alarm</v-icon>
          </slot>
        </v-tab>
        <v-tab-item key="calendar">
          <v-date-picker scrollable reactive
            ref="picker"
            v-model="datePart"
            :max="max"
            :min="min"
            :picker-date="defaultValue"
            class="elevation-0"
          />
        </v-tab-item>
        <v-tab-item key="timer">
          <v-time-picker scrollable reactive ref="timer" v-model="timePart" class="elevation-0">
          </v-time-picker>
        </v-tab-item>
      </v-tabs>
      <v-date-picker scrollable reactive
        v-else
        ref="picker"
        v-model="datePart"
        :max="max"
        :min="min"
        :picker-date="defaultValue"
        class="elevation-0"
      />

      <v-card-actions>
        <v-spacer />
        <v-btn flat color="grey" @click.native="dismiss">Cancel</v-btn>
        <v-btn color="primary" @click.native="update">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'
const DEFAULT_TIME_FORMAT = 'HH:mm'
const DEFAULT_TIME = '00:00'

// Vue Component
export default {
  name: 'DatePicker',
  props: {
    appendIcon: { type: String },
    clearable: { type: Boolean, default: () => false },
    defaultValue: { type: String },
    errorMessages: { type: Array, default: () => [] },
    hint: { type: String, default: '' },
    label: { type: String },
    max: { type: String },
    min: { type: String },
    placeholder: { type: String, default: 'Pick a date' },
    prependIcon: { type: String },
    required: { type: Boolean },
    rules: { type: Array, default: () => [] },
    theme: { type: Object },
    type: { type: String, default: 'date' },
    value: { type: String },
    yearsFirst: { type: Boolean, default: false },
  },

  data() {
    return {
      // Models
      activeTab: 0,
      modified: this.value ? new Date(this.value) : new Date(),
      // Toggles
      dateSelected: false,
      timeSelected: false,
      visible: false,
    }
  },
  computed: {
    display() {
      if (this.type === 'datetime') {
        return this.value ? this.$date(new Date(this.value), 'd MMMM yyyy - HH:mm') : null
      }

      return this.value ? this.$date(new Date(this.value), 'd MMMM yyyy') : null
    },
    datePart: {
      get() {
        return this.modified ? this.$date(new Date(this.modified), DEFAULT_DATE_FORMAT) : ''
      },
      set(val) {
        this.dateSelected = true
        this.activeTab = 1
        let date = new Date(val)
        this.modified = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
      },
    },
    timePart: {
      get() {
        return this.modified ? this.$date(this.modified, DEFAULT_TIME_FORMAT) : DEFAULT_TIME
      },
      set(val) {
        this.timeSelected = true
        let date = new Date(this.modified)
        this.modified = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          val.split(':')[0],
          val.split(':')[1],
          0
        )
      },
    },
  },

  watch: {
    visible(val) {
      val && this.yearsFirst && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
  },

  methods: {
    dismiss() {
      this.visible = false
    },
    update() {
      this.visible = false
      this.$emit('input', this.$date(new Date(this.modified)))
    },
    clear() {
      this.visible = false
      this.modified = null
      this.$emit('input', null)
    },
  },
}
</script>
